<template>
    <v-icon
        :title="$attrs.title"
        :class="{'grey--text lighten-1': isDark, 'grey--text darken-1': !isDark}"
        v-text="icons.mdiLock"
        class="mx-1"
        x-small
    ></v-icon>
</template>
<script>
import MixinIcon from "@/mixins/MixinIcon";
import MixinDark from "@/mixins/database/MixinDark";

export default {
    name: 'IconsMaster',
    mixins: [MixinIcon, MixinDark],

}
</script>
